import React from "react";
import loader from "../../images/main-loader.jpg";
import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { EyeSlash, EyeFill } from "react-bootstrap-icons";
import { auth } from "../../firebase-config.js";
import { signInWithEmailAndPassword } from "firebase/auth";
import LoadScreen from "../LoadScreen";
import ReCAPTCHA from "react-google-recaptcha";
import { setPersistence, browserSessionPersistence } from "firebase/auth";

const SignIn = () => {
  const siteKey = "6Lf3VwIiAAAAAM0OueZ7K7yt8VpmyiK0Oks-2t49";
  const [loginEmail, setloginEmail] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [loginPassword, setloginPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordErrorMsg, setpasswordErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [recaptcha, setRecaptcha] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState("");

  const renderRedirect = () => {
    if (redirect) return <Navigate to="/Home" />;
  };

  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const login = async (event) => {
    event.preventDefault();
    try {
      if (recaptcha) {

        

        const signInUserCred = await signInWithEmailAndPassword(
          auth,
          loginEmail,
          loginPassword
        );

        // console.log("Hello");

        const user = signInUserCred.user;
        const currentUser = user.currentUser;

        console.log(user);

        if (!auth.currentUser.emailVerified)
          throw setErrorMsg(
            "Email not verified...Please check inbox to verify."
          );

        setIsLoading(true);
        // console.log("Sign in user " + JSON.stringify(auth.currentUser.uid));

        // window.localStorage.setItem('isLoggedIn',true);

        setErrorMsg("");
        setEmailErrorMsg("");
        setpasswordErrorMsg("");
        setRecaptchaError("");
        setSuccessMsg("Account Created Successfully !");

        setTimeout(() => {
          setIsLoading(false);
          // console.log("Tried nav");
          setRedirect(true);
        }, 3000);
      }

      else setRecaptchaError("Please check Recapthca");
      // sendEmailVerification(user);
    }

    catch (error) {
      // console.log(error.message);
      if (recaptcha == false) {
        setRecaptchaError("Please check Recapthca");
        // console.log("Please check Recapthca ");
      }
      if (error.message == "Firebase: Error (auth/user-not-found).")
        setErrorMsg("User not found!");

      if (error.message == "Firebase: Error (auth/wrong-password).")
        setErrorMsg("Wrong password");

      if (
        error.message ==
        "Firebase: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later. (auth/too-many-requests)."
      )
        setErrorMsg(
          "Your account has been disabled for making several attempts"
        );
      if (loginEmail.length == 0) {
        setEmailErrorMsg("Email cannot be empty");
      }

      if (loginPassword.length == 0) {
        setpasswordErrorMsg("Password cannot be empty");
      }

      if (
        loginEmail.length != 0 &&
        error.message == "Firebase: Error (auth/invalid-email)."
      ) {
        setEmailErrorMsg("Invalid Email Used");
      }

      setIsLoading(false);
      setSuccessMsg("");
    }

    setTimeout(() => {
      setErrorMsg("");
      setEmailErrorMsg("");
      setpasswordErrorMsg("");
      setRecaptchaError("");
    }, 7000);
  };
  return (
    <>
      {isLoading ? (
        <LoadScreen />
      ) : (
        <div className="createAcDiv">
          {/* v1!edangsar */}
          <section id="contact">
            <div className="contact-box">
              <div className="contact-links">
                <h2 className="signUpHeader">Sign In</h2>
                <img src={loader} height="150px" width="100%" alt="AVION" />
                {/* <div className="createAcSpan">
              By creating an account you will be able to save your addresses and
              save items in cart.
            </div> */}
              </div>

              <div className="contact-form-wrapper">
                {successMsg && (
                  <>
                    <div className="successDiv">{successMsg}</div>
                  </>
                )}
                {errorMsg && (
                  <>
                    <div className="errorDiv">{errorMsg}</div>
                  </>
                )}
                <form className="signUpForm" method="POST">
                  {renderRedirect()}
                  <div className="form-item">
                    <input
                      className="inputFields"
                      type="text"
                      onChange={(event) => {
                        setloginEmail(event.target.value);
                      }}
                      value={loginEmail}
                      name="email"
                      required
                    />
                    <label>Email</label>
                    <div className="inputErrors">{emailErrorMsg}</div>
                  </div>

                  <div className="form-item">
                    <input
                      className="inputFields"
                      type={passwordType}
                      onChange={(event) => {
                        setloginPassword(event.target.value);
                        // handlePasswordChange()
                      }}
                      name="password"
                      value={loginPassword}
                      required
                    />
                    <label>Password</label>
                    <div className="eye" onClick={togglePassword}>
                      {passwordType === "password" ? <EyeSlash /> : <EyeFill />}
                    </div>
                    <div id="passwordError" className="inputErrors">
                      {passwordErrorMsg}
                    </div>
                  </div>
                  <div className="form-item">
                    <ReCAPTCHA
                      onChange={() => setRecaptcha(true)}
                      sitekey={siteKey}
                    />
                    <div className="inputErrors">{recaptchaError}</div>

                    <div className="redirectLinksDiv">
                      <Link className="redirectLinks" to="/SendResetEmail">
                        Forgot Password?
                      </Link>
                    </div>
                  </div>

                  <button onClick={login} className="submit-btn">
                    Sign In
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default SignIn;
